module.exports = __webpack_public_path__ + "img/ic_dinghuoxitong@2x.3a8b7843.png";